// Navbar.js
import React, { useState } from 'react';
import logo from './images/Vector.png';
import '../App.css'; // If you need custom styles

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className=" navbar navbar-expand-md navbar-dark custom-navbar sticky-top">
      <div className='container'>
      <a className="navbar-brand" href="#home">
        <img src={logo} alt="Logo" width="80" height="40" />
      </a>

      <button
        className="navbar-toggler"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      <div className={`navbar-collapse justify-content-end ${isOpen ? 'show d-block' : 'collapse'}`}>
        <ul className="navbar-nav gap-4">
          <li className="nav-item">
            <a className="nav-link" href="#home" onClick={() => setIsOpen(false)}>Home</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#about" onClick={() => setIsOpen(false)}>About</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#features" onClick={() => setIsOpen(false)}>Features</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#contact" onClick={() => setIsOpen(false)}>Contact</a>
          </li>
        </ul>
      </div>
      </div>
    </nav>
  );
}
